import React from "react";
import { connect } from "react-redux";
import ListItemText, {
    Typography,
    IconButton,
    WithStyles,
    withStyles,
    ListItem,
    Grid,
    Button,
} from "material-ui";
import ErrorOutlineIcon from "material-ui-icons/ErrorOutline";
import moment from "moment";

import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import AlternatingList from "../../components/AlternatingList";
import { LoanPieChart } from "../../components/LoanPieChart/LoanPieChart";
import {
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
    SetHeader,
} from "../../ducks/common";
import {
    getLoan,
    getLoanData,
    emptyLoanData,
    getAllLoans,
    getAllLoansData,
    Loans,
    getAllLoansArray,
} from "../../ducks/loan";
import { LoanDto } from "../../util/DTOs/LoanDtos";
import { RouteComponentProps, RouterProps } from "react-router";
import { formatNumber, highToLow } from "../../util/utils";
import SwipeableViews from "react-swipeable-views";
import LoanPage from "./LoanPage";
import logger from "../../util/logger";
import ChevronLeftIcon from "material-ui-icons/ChevronLeft";
import ChevronRightIcon from "material-ui-icons/ChevronRight";
import FullPageSpinner from "../../components/FullPageSpinner/FullPageSpinner";

const sortLoans = (a: LoanDto, b: LoanDto) => {
    return highToLow(
        a.currentOutstandingPrincipalAmount || 0,
        b.currentOutstandingPrincipalAmount || 0
    );
};

const styles = {
    container: {
        paddingRight: 20,
        paddingLeft: 20,
        marginBottom: 60,
    },
    subheadingWeight: {
        fontWeight: "200",
    },
    centerText: {
        textAlign: "center",
    },
    rightText: {
        textAlign: "right",
    },
    flexRoot: {
        display: "flex",
        width: "100%",
    },
    flexItem: {
        flex: 1,
    },
} as React.CSSProperties;

interface ILoansPageProps extends RouteComponentProps<{ id?: string }> {}
interface ILoansPageReduxProps {}
interface ILoansPageDispatchProps {
    setHeaderValue: (header: string) => void;
    showLogo: (show: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
}
interface ILoansPageReduxProps {
    loanData: LoanDto[]; //Loans;
}
interface ILoansPageDispatchProps {
    getLoansData: () => Promise<void>;
}

interface LoansPageState {
    currentIndex: number;
    loading: boolean;
}

type LoansPageProps = ILoansPageProps &
    ILoansPageReduxProps &
    ILoansPageDispatchProps &
    RouterProps;

type LoansPagePropsWithStyles = LoansPageProps &
    WithStyles<
        | "container"
        | "subheadingWeight"
        | "centerText"
        | "rightText"
        | "flexRoot"
        | "flexItem"
    >;

class LoansPage extends React.Component<
    LoansPagePropsWithStyles,
    LoansPageState
> {
    constructor(props: LoansPagePropsWithStyles) {
        super(props);
        this.state = { currentIndex: 0, loading: true };
    }
    componentDidMount() {
        this.props.setBackButton("/");
        this.props
            .getLoansData()
            .then(() => this.setState({ ...this.state, loading: false }))
            .catch((err) => {
                logger.error(err);
                this.setState({ ...this.state, loading: false });
            });

        this.props.setHeaderValue("Lainat");
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps: LoansPagePropsWithStyles) {
        if (nextProps.match.params.id) {
            let index = nextProps.loanData.findIndex((item) => {
                return Number(item.id) === Number(nextProps.match.params.id);
            });

            if (index !== -1 && this.state.currentIndex !== index) {
                this.setState({ currentIndex: index });
                this.setHeaderValue(index);
            }
        }
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.setHeaderValue("");
    }

    setIndex(index: number) {
        if (this.props.match.params.id) {
            this.props.history.replace("/loan");
        }

        const keys = this.props.loanData;
        if (
            index >= keys.length ||
            index < 0 ||
            this.state.currentIndex === index
        ) {
            return;
        }
        this.setState({ currentIndex: index, loading: false });
        this.setHeaderValue(index);
    }

    setHeaderValue = (index: number) => {
        const loan = this.props.loanData[index];

        if (loan) {
            this.props.setHeaderValue(loan.loanName || loan.loanTypeName);
        }
    };

    render() {
        const loans = this.props.loanData.map((loan, index) => {
            return (
                <LoanPage
                    key={loan.id}
                    id={loan.id}
                    {...this.props}
                    isVisibleView={index === this.state.currentIndex}
                />
            );
        });

        return (
            <div className="page-container">
                <FullPageSpinner loading={this.state.loading} />
                <SwipeableViews
                    index={this.state.currentIndex}
                    onChangeIndex={(i: number) => this.setIndex(i)}
                >
                    {(loans && loans.length > 0 && loans) || (
                        <div className="centered-message-container">
                            <h2 className="hypodgrey">EI LAINOJA</h2>
                        </div>
                    )}
                </SwipeableViews>
                {this.state.currentIndex > 0 && (
                    <div id="gallery-prev-btn">
                        <Button
                            onClick={() =>
                                this.setIndex(this.state.currentIndex - 1)
                            }
                        >
                            <ChevronLeftIcon
                                style={{
                                    height: "48px",
                                    width: "48px",
                                    color: "rgba(0,0,0,0.5)",
                                }}
                            />
                        </Button>
                    </div>
                )}
                {this.state.currentIndex < this.props.loanData.length - 1 && (
                    <div id="gallery-next-btn">
                        <Button
                            onClick={() =>
                                this.setIndex(this.state.currentIndex + 1)
                            }
                        >
                            <ChevronRightIcon
                                style={{
                                    height: "48px",
                                    width: "48px",
                                    color: "rgba(0,0,0,0.5)",
                                }}
                            />
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: LoansPageProps
): ILoansPageReduxProps => {
    let loanData = getAllLoansArray(state);
    loanData = loanData.sort(sortLoans);
    return {
        loanData: loanData,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ILoansPageDispatchProps => {
    return {
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        getLoansData: async () => {
            await dispatch(getAllLoans());
        },
    };
};

export default connect<
    ILoansPageReduxProps,
    ILoansPageDispatchProps,
    ILoansPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(LoansPage));



// WEBPACK FOOTER //
// ./src/views/loan/LoansPage.tsx